import React, { FunctionComponent, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { setIsNewFeed } from 'Redux/actions/auth'
import { getIsNewFeed, getIsFeedBanner } from 'Redux/selectors/auth'

import { TrackList, TestingModeBanner } from './components'
import { ContainerTracksFeed, PageTitle } from './styles'

const TracksFeed: FunctionComponent = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isNewFeed = useSelector(getIsNewFeed)
  const isFeedBanner = useSelector(getIsFeedBanner)

  const [visibleContent, setVisibleContent] = useState(true)
  useEffect(() => {
    isNewFeed && dispatch(setIsNewFeed())
  }, [isNewFeed])

  const visibleContentMobile =
    (visibleContent && window.innerWidth < 576) || window.innerWidth >= 576

  return (
    <ContainerTracksFeed>
      {visibleContentMobile && (
        <>
          <PageTitle>{t('tracksFeedPage.pageTitle')}</PageTitle>
        </>
      )}
      {typeof isFeedBanner !== 'undefined' &&
        isFeedBanner &&
        visibleContentMobile && <TestingModeBanner />}
      <TrackList setVisibleContent={setVisibleContent} />
    </ContainerTracksFeed>
  )
}

export default TracksFeed
